module.exports = __webpack_public_path__ + "img/sozialschnellgut_1_a.b8649dc0.jpg";